<script lang="ts" setup>
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import type { RouteLocationRaw } from "vue-router";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import { useVocabAchievementProgress } from "@/common/composables/use-vocab-achievement-progress";
import { useVocabAchievements } from "@/common/composables/use-vocab-achievements";
import BadgeRedemptionModal from "@/components/modals/vocabularyTrainer/BadgeRedemptionModal.vue";
import QuizJumbotron from "@/components/vocabularyTrainer/QuizJumbotron.vue";

import AchievementItem from "./AchievementItem.vue";

defineProps<{
  returnLocation: RouteLocationRaw;
}>();

const { t } = useI18n();

const { achievementHasMultipleTiers } = useVocabAchievements();

const {
  sortedAchievements,
  redeemBadge,
  isRedemptionModalOpen,
  loadAchievements,
  onRedeemClick,
  onCloseRedemptionModal,
  onBadgeRedeem
} = useVocabAchievementProgress();

onMounted(loadAchievements);
</script>

<template>
  <QuizJumbotron>
    <div class="container">
      <div class="row jumbotron-inner">
        <AbcHeading tag="h1" size="xl">
          {{ t("vocab.quizAchievementProgress.jumbotronHeading") }}
        </AbcHeading>
      </div>
    </div>
  </QuizJumbotron>

  <div class="quiz-achievement-progress-content container">
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <AchievementItem
          v-for="achievement in sortedAchievements"
          :key="`${achievement.slug}-${achievement.steps}`"
          :achievement="achievement"
          :show-steps-in-name="achievementHasMultipleTiers(achievement)"
          class="mb-4"
          @redeem-click="onRedeemClick(achievement)"
        />
        <BadgeRedemptionModal
          :is-open="isRedemptionModalOpen"
          :badge="redeemBadge"
          @close="onCloseRedemptionModal()"
          @redeem="onBadgeRedeem()"
        />
      </div>
    </div>
  </div>

  <div class="quiz-achievement-progress-button-container container">
    <div class="row">
      <TgButton tag="router-link" :to="returnLocation" size="lg">
        {{ t("vocab.quizAchievementProgress.finish") }}
      </TgButton>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.jumbotron-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 28px 0;
  text-align: center;

  #media-breakpoint-up(md, {
    margin: 85px 0 110px;
  });
}

.quiz-achievement-progress-content {
  margin: 44px auto 0;
}

.quiz-achievement-progress-button-container {
  display: flex;
  justify-content: center;
  margin: 20px auto 44px;
}
</style>
